<template>
  <div>
    <v-slide-y-transition>
      <div v-if="advertisementGroups.advertisements.length">
        <v-btn
          v-if="advertisementGroups.activeAd && advertisementGroups.activeAd.link"
          text
          small
          outlined
          rounded
          color="primary"
          target="_blank"
          class="mx-1 px-4 text-secondary"
          style="position: absolute"
          @click="goToAdvetisementLinkIndex(advertisementGroups.activeAd)"
        >
          {{ advertisementGroups.activeAd.action_text ? advertisementGroups.activeAd.action_text : $t('advertisements.goToAd')}}
        </v-btn>
        <Carrousel
          :advertisements="advertisementGroups.advertisements"
          @setActiveAd="setActiveAd"
          @goToAdvetisementLinkIndex="goToAdvetisementLinkIndex"
        />
        <div
          v-if="advertisementGroups.activeAd"
          id="ad-caption"
          class="px-5 mt-1"
        >
          <span class="caption">{{advertisementGroups.activeAd.description}}</span>
        </div>
        <div
          v-if="advertisementGroups.activeAd"
          id="actions"
        >
        </div>
      </div>
    </v-slide-y-transition>
  </div>
</template>

<script>
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'
import MainService from '@/services/MainService'

@Component({
  components: {
    Loading: () => import(/* webpackPrefetch: true */ '@/components/Loading.vue'),
    Carrousel: () => import(/* webpackPrefetch: true */ '@/views/advertisements/resources/Carrousel.vue')
  }
})
export default class Advertisements extends Vue {
  data () {
    return {
      advertisementGroups: {
        list: [],
        loading: false,
        advertisements: [],
        activeAd: null
      }
    }
  }

  mounted () {
    this.index()
  }

  setActiveAd (activeAd) {
    this.advertisementGroups.activeAd = activeAd
  }

  goToAdvetisementLinkIndex (advertisement) {
    if (advertisement.link) {
      window.open(advertisement.link, '_blank')
    }
  }

  async index () {
    this.advertisementGroups.loading = true
    const data = {
      route: 'ocular/widget/ad_groups',
      params: {
        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
      }
    }

    return MainService.get(data)
      .then((response) => {
        const res = response.data
        if (res.statusCode === 0) {
          this.advertisementGroups.list = response.data.data

          for (let advertisementGroupsIndex = 0; advertisementGroupsIndex < this.advertisementGroups.list.length; advertisementGroupsIndex++) {
            const groupAdvertisement = this.advertisementGroups.list[advertisementGroupsIndex]

            for (let advertisementIndex = 0; advertisementIndex < groupAdvertisement.advertisements.length; advertisementIndex++) {
              const advertisement = groupAdvertisement.advertisements[advertisementIndex]
              this.advertisementGroups.advertisements.push(advertisement)
            }
          }
        }
      })
      .catch((e) => {
        console.log(e)
      })
      .then(() => {
        this.advertisementGroups.loading = false
      })
  }
}
</script>
